import dynamic from "next/dynamic";
import classNames from "classnames";

import styles from "./styles.module.css";

const GptAd = dynamic(() => import("components/gpt-ad-element"), { ssr: false });

const VodafoneAd = () => {
  const vodafoneBannerAdUnitClass = classNames(styles.adline, styles.vodafoneAdUnit);
  return (
    <div className={vodafoneBannerAdUnitClass}>
      <GptAd elementId="div-gpt-ad-1753440478617-0" />
    </div>
  );
};

export default VodafoneAd;
